/**
 * Choose Your Birdie Slider Web Component
 * Clean, minimal slider implementation using Swiper.js
 */

class ChooseYourBirdieSlider extends HTMLElement {
	constructor() {
		super();
		this.swiper = null;
	}

	connectedCallback() {
		// Only initialize on mobile/tablet devices (temporarily increased for testing)
		if (window.innerWidth <= 1200) {
			this.initializeSlider();
		}

		// Handle resize
		window.addEventListener('resize', () => this.handleResize());
	}

	disconnectedCallback() {
		this.destroySlider();
		window.removeEventListener('resize', this.handleResize);
	}

	initializeSlider() {
		// Check if Swiper is loaded
		if (typeof Swiper === 'undefined') {
			console.error('Swiper.js is not loaded');
			return;
		}

		const swiperContainer = this.querySelector('.choose-your-birdie-swiper');
		if (!swiperContainer) return;

		// Get settings from data attributes
		const enableAutoplay = swiperContainer.dataset.enableAutoplay === 'true';
		const autoplayDelay = parseFloat(swiperContainer.dataset.autoplayDelay) || 4;
		const showDots = swiperContainer.dataset.showDots === 'true';
		const showArrows = swiperContainer.dataset.showArrows === 'true';

		// Initialize Swiper with optimized smooth configuration
		try {
			this.swiper = new Swiper(swiperContainer, {
				slidesPerView: 1.2, // Show 1 full slide + 0.2 of next/prev
				slidesPerGroup: 1, // Move 1 slide at a time
				spaceBetween: 20,
				centeredSlides: true, // Center the active slide
				loop: false,
				speed: 300,
				initialSlide: 1, // Start on 2nd slide (index 1)

				// Ensure 1 slide per view on all screen sizes
				breakpoints: {
					0: {
						slidesPerView: 1.2,
						spaceBetween: 16
					},
					480: {
						slidesPerView: 1.2,
						spaceBetween: 16
					},
					768: {
						slidesPerView: 1.2,
						spaceBetween: 16
					}
				},

				// Smooth touch interactions
				touchRatio: 1,
				grabCursor: true,
				simulateTouch: true,
				allowTouchMove: true,

				// Disable resistance at edges for smoother feel
				resistance: false,

				// Better threshold for drag detection
				threshold: 10,
				shortSwipes: true,
				longSwipes: true,
				followFinger: true,

				// Autoplay
				autoplay: enableAutoplay ? {
					delay: autoplayDelay * 1000,
					disableOnInteraction: false,
					pauseOnMouseEnter: true, // Pause on hover for better UX
				} : false,

				// Navigation
				navigation: showArrows ? {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				} : false,

				// Pagination
				pagination: showDots ? {
					el: '.swiper-pagination',
					clickable: true,
				} : false,
			});
		} catch (error) {
			console.error('Error creating Swiper:', error);
		}
	}

	destroySlider() {
		if (this.swiper) {
			this.swiper.destroy(true, true);
			this.swiper = null;
		}
	}

	handleResize() {
		const isMobile = window.innerWidth <= 1200; // Temporarily increased for testing

		if (isMobile && !this.swiper) {
			// Initialize slider for mobile
			setTimeout(() => this.initializeSlider(), 100);
		} else if (!isMobile && this.swiper) {
			// Destroy slider for desktop
			this.destroySlider();
		}
	}
}

// Register the web component
customElements.define('choose-your-birdie-slider', ChooseYourBirdieSlider);
